import axios from "axios";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PlusIcon from "../../../assets/plus-icon.png";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

const BASE_URL = process.env.REACT_APP_API_URL;

export default function StatusModal({ getStatusData }) {
  const [isLoading, setIsLoading] = useState(false);
  const [showStatus, setShowStatus] = useState(false);

  const navigate = useNavigate();

  const handleNameClose = () => {
    setShowStatus(false);
    reset();
  };

  const schema = Yup.object({
    status: Yup.string()
      .max(20, "Status is not greater than 20 characters")
      .required("Status is required."),
    color: Yup.string().required("Color is required."),
    checkbox: Yup.boolean().required("Requried"),
  }).required();

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    mode: "all",
    resolver: yupResolver(schema),
    defaultValues: {
      checkbox: true,
      color: "#f04d4d",
    },
  });

  const handleShow = () => {
    setShowStatus(true);
  };

  const onSubmit = async (data) => {
    const token = localStorage.getItem("token");
    let body = {
      status_name: data?.status,
      status_color: data?.color,
      is_status_active: data?.checkbox,
    };
    setIsLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/create-status`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.success === 1) {
        toast.success(response?.data?.message);
        getStatusData();
        setShowStatus(false);
        reset();
      }
    } catch (error) {
      if (error?.response?.data) {
        if (
          error.response.data.message === "Session expired please login again"
        ) {
          // Handle session expiration
          localStorage.removeItem("token");
          navigate("/");
          toast.error(error?.response?.data?.message);
        } else {
          toast.error(error?.response?.data?.message);
        }
      } else {
        toast.error("Something went wrong");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="text-end mb-4">
        <button className="add-user-button" onClick={handleShow}>
          <span className="me-2">
            <img alt="" src={PlusIcon} />
          </span>
          Add Status
        </button>
      </div>
      <Modal centered show={showStatus} onHide={handleNameClose}>
        <Modal.Header closeButton className="border-0">
          {/* <Modal.Title>Modal heading</Modal.Title> */}
        </Modal.Header>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body>
            <p className="fw-semibold">Add Status</p>
            <Controller
              name="status"
              control={control}
              render={({ field }) => (
                <input
                  {...field}
                  id="status"
                  type="text"
                  value={field?.value || ""}
                  autoComplete="off"
                  className="form-control px-2 input-boxshadow-none"
                  placeholder="Status"
                  onChange={(e) => {
                    field.onChange(e);
                  }}
                  onBlur={field.onBlur}
                />
              )}
            />
            <p className="text-danger py-2 mb-0">{errors?.status?.message}</p>
            <p className=" py-2 mb-0 fw-semibold">Select Color</p>
            <Controller
              name="color"
              control={control}
              render={({ field }) => (
                <input
                  {...field}
                  id="color"
                  type="color"
                  autoComplete="off"
                  className="form-control px-2 input-boxshadow-none"
                  style={{ height: "38px" }}
                  onChange={(e) => {
                    field.onChange(e);
                  }}
                  onBlur={field.onBlur}
                />
              )}
            />
            <p className="text-danger py-2 mb-0">{errors?.color?.message}</p>
            <div className="mt-4">
              <Controller
                name="checkbox"
                control={control}
                render={({ field }) => (
                  <input
                    className="form-check-input largerCheckbox"
                    type="checkbox"
                    {...field}
                    checked={field?.value}
                    id="invalidCheck2"
                    onChange={(e) => {
                      field.onChange(e);
                    }}
                  />
                )}
              />
              <label
                className="form-check-label text-black ms-2"
                htmlFor="invalidCheck2"
                style={{ marginTop: "2px" }}
              >
                Active
              </label>
              <p className="text-danger py-2 mb-0">
                {errors?.checkbox?.message}
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0">
            <button
              type="submit"
              className="text-white btn"
              style={{ backgroundColor: "#336BA6" }}
            >
              Add
              {isLoading && (
                <div
                  className="spinner-border spinner-border-sm ms-3"
                  role="status"
                >
                  <span className="sr-only"></span>
                </div>
              )}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}
